export * from './customer.service';
import { CustomerService } from './customer.service';
import { LegacyService } from './legacy.service';
export * from './oneqrew.service';
import { OneqrewService } from './oneqrew.service';
export const APIS = [CustomerService, OneqrewService, LegacyService];
